var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('b-loading', {
    attrs: {
      "active": _vm.modelLoading
    }
  }), _vm._v(" "), _c('section', {
    staticClass: "container has-text-centered"
  }, [_c('landmarks-list'), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('file-upload', {
    attrs: {
      "on-input": _vm.onInput
    }
  }), _vm._v(" "), (_vm.modelLoading) ? _c('div', [_c('br'), _vm._v(" "), _c('p', [_vm._v("Model is loading...")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('progress', {
    staticClass: "progress",
    attrs: {
      "value": _vm.loadingProgress,
      "max": "100"
    }
  }), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.loadingProgress) + "%")])]) : _vm._e()], 1), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('section', {
    staticClass: "container has-text-centered"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.modelRunning || _vm.output),
      expression: "modelRunning || output"
    }],
    staticClass: "card"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "card-content"
  }, [(_vm.modelRunning) ? _c('div', {
    staticClass: "loader model-loader"
  }) : (_vm.outputClass) ? _c('div', [_c('h3', {
    staticClass: "is-size-2"
  }, [_vm._v(_vm._s(_vm.outputClass))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.outputClassDescription.body))]), _vm._v(" "), _c('p', [_c('a', {
    attrs: {
      "target": "_blank",
      "rel": "noopener",
      "href": _vm.outputClassDescription.url
    }
  }, [_vm._v("\n              Learn more\n            ")])])]) : _vm._e()])])])], 1)
}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-image"
  }, [_c('figure', {
    staticClass: "image has-text-centered"
  }, [_c('canvas', {
    attrs: {
      "id": "input-canvas",
      "width": "150",
      "height": "150"
    }
  })])])
}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7261d37b","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/HeroBody.vue
// module id = oHIW
// module chunks = 1